import { ViewModel } from './model';
import html from './template.html';
import './style.less';

ko.components.register('table-header', {
  viewModel: {
    createViewModel: (params, componentInfo) => {
      let element = componentInfo.element;
      element.classList.add('table-header');

      return new ViewModel(params, element);
    },
  },
  template: html,
});